import { all, call, put, takeEvery } from 'redux-saga/effects'
import AssetManagementApiService from './AssetManagementApiService'
import { apiMethod, apiType, API_URL, getFileName } from 'utils';
import { setAttachments } from 'Store/AssetManagement/UploadAttachments/UploadAttachmentsAction';
import { UPLOAD_ATTACHMENTS } from 'Store/AssetManagement/UploadAttachments/UploadAttachmentsType';
import { globalLoaderText } from 'redux/CommonDashboard/actions';

function* uploadAttachments(req: any): any {
    try {
        yield put(globalLoaderText("Uploading Attachments...."));
        let fileObjList = req.attachmentList.formData;
        const list = req.attachmentList.filteredList;
        const CurrentAttachmentlist = req.attachmentList.list;

        fileObjList.append("apiMethod", apiMethod.POST)
        fileObjList.append("apiType", apiType.AssetManagement)
        fileObjList.append("endpoint", `assets/upload/attachments`) 
        
        const response = yield call(AssetManagementApiService.post, `${API_URL.PostWebApp}/upload/attachments`, fileObjList);

        // Converting attachment URL to object
        const updatedResponse = response
            .map((x: string) => {
                const obj = list.find((y: any) => getFileName(x) === y.name);
                if (obj) {
                    return {
                        fileName: obj.name,
                        mimeType: obj.type,
                        attachmentUrl: x,
                    };
                }

                return null;
            })
            .filter((x: any) => !!x);
        yield put(globalLoaderText(""));
        yield put(setAttachments([...CurrentAttachmentlist, ...updatedResponse]));
    } catch (error) {
        yield put(globalLoaderText(""));
        yield put(setAttachments([]));
    }
}

function* watchGetUploadAttachments() {
    yield takeEvery(UPLOAD_ATTACHMENTS, uploadAttachments)
}

export default function* combinedSaga() {
    yield all([
        watchGetUploadAttachments()
    ])
}